import React from 'react';
import './App.css';
import CodeEditor from './components/CodeEditor';

function App() {
  return (
    <div className="App">
      <CodeEditor />
    </div>
  );
}

export default App;
